import { render, staticRenderFns } from "./trip-item-table.vue?vue&type=template&id=f3957be2&scoped=true&"
import script from "./trip-item-table.vue?vue&type=script&lang=js&"
export * from "./trip-item-table.vue?vue&type=script&lang=js&"
import style0 from "./trip-item-table.vue?vue&type=style&index=0&id=f3957be2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3957be2",
  null
  
)

export default component.exports